export default {
    baseStyle: () => ({
        container: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            bg: 'stokkeCore.white',
            padding: 2,
            border: '1px',
            borderColor: 'stokkeGray.mid',
            cursor: 'pointer'
        },
        imageWrapper: {
            position: 'relative',
            width: '5rem',
            height: '6.25rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            sx: {
                '&:is(:hover, :focus-within) [data-not-hovered="container"]': {
                    opacity: 0
                },
                '&:not(:is(:hover, :focus-within)) [data-hovered="container"]': {
                    opacity: 0
                }
            }
        },
        colorVariantContainer: {
            alignItems: 'flex-start',
            gap: 2
        },
        colorSwatches: {
            alignItems: 'center',
            gap: 1
        },
        checkboxContainer: {
            display: 'none'
        },
        priceContainer: {
            display: 'none'
        }
    }),
    variants: {
        selectable: ({isSelected}) => ({
            container: {
                ...(isSelected && {
                    borderColor: 'stokkeCore.black'
                })
            },
            colorVariantContainer: {
                alignItems: 'flex-start',
                flexDirection: 'column',
                gap: 1
            },
            checkboxContainer: {
                display: 'block'
            },
            priceContainer: {
                display: 'block',
                marginInlineStart: 'auto'
            }
        })
    }
}
